import BootstrapTable from 'react-bootstrap-table-next'
import React, { Component, useState } from 'react'
import FolderContext from '../contexts/FolderContext'
import { withRouter } from 'react-router-dom'
import { get, filter } from 'lodash'
import { getFileIcon } from '../utils/listFunctions'
import FileIconRow from './FileIconRow'
import {
  bytesFormatter,
  processStatusConstants,
} from '../utils/fileSizeFunctions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBoxOpen } from '@fortawesome/free-solid-svg-icons'
import { dateFormatter } from '../utils/dateFunctions'
import RowsContext from './RowsContext'
import { Dropdown, DropdownButton } from 'react-bootstrap'
import RestoreFileModal from './RestoreFileModal'
import PropTypes from 'prop-types'

class DeletedFileTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedRows: get(props, 'selectedRows', []),
      files: get(props, 'deletedFiles', []),
      imageFiles: filter(get(props, 'deletedFiles', []), function (o) {
        return o.contentType.includes('image')
      }),
    }

    // function binds
    // this.onTableChange = this.onTableChange.bind(this);
    // this.handleOnCheckBoxChange = this.handleOnCheckBoxChange.bind(this);
    // this.handleTitleTextChange = this.handleTitleTextChange.bind(this);
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.deletedFiles !== this.props.deletedFiles) {
      this.setState({
        files: get(this.props, 'deletedFiles', []),
      })
    }
  }
  render() {
    const columns = [
      {
        dataField: 'name',
        text: 'Name',
        sort: false,
        classes: 'td-name',
        formatter: (cell, row) => {
          let itemId = `${this.props.itemId}`
          let length = itemId.length
          if (row.key) cell = row.key.substring(length + 1)
          return (
            <div className="text-collapse">
              <div className="table-icon-left">{getFileIcon(cell)}</div>
              <div className="table-row-title ">
                <span>{cell}</span>
                <div className="table-icon-right">
                  <FileIconRow file={row} />{' '}
                  {row.processStatus === 'unzipped' ? (
                    <>
                      <span>
                        <FontAwesomeIcon icon={faBoxOpen} />{' '}
                      </span>
                    </>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          )
        },
      },
      {
        dataField: 'contentType',
        text: 'Type',
        sort: false,
        formatter: (cell) => {
          return <div className="text-collapse">{cell}</div>
        },
      },
      {
        dataField: 'size',
        text: 'File Size',
        sort: false,
        formatter: (cell) => {
          return bytesFormatter(cell, 2)
        },
      },
      {
        dataField: 'location',
        text: 'Location',
        sort: false,
        formatter: (cell, row) => {
          let location = ''
          if (row.published) location = 'SB Public Cloud'
          return row.published ? location : 'Deleted'
        },
      },
      {
        dataField: 'input',
        text: 'Title',
        formatter: (_, row) => {
          return row.title ? row.title : ''
        },
      },
      {
        dataField: 'lastUpdatedBy',
        text: 'last Updated User',
        sort: false,
        formatter: (cell) => {
          return <div className="text-collapse">{cell}</div>
        },
      },
      {
        dataField: 'lastUpdated',
        text: 'Last Updated Date',
        sort: false,
        formatter: (cell) => {
          return <div className="text-collapse">{dateFormatter(cell)}</div>
        },
      },
      {
        dataField: 'processStatus',
        text: 'Status',
        sort: false,
        formatter: (cell, row) => {
          switch (cell) {
            case processStatusConstants.UPLOAD_SUCCESS:
              cell = 'File uploaded, scanning'
              break
            case processStatusConstants.UPLOAD_FAILED:
              cell = 'File upload failed'
              break
            case processStatusConstants.SCAN_SUCCESS:
              cell = 'File scanned, clean'
              break
            case processStatusConstants.SCAN_FAILED:
              cell = 'File scanned, infected'
              break
            case processStatusConstants.SCAN_SKIPPED:
              cell = 'File scanned, skipped'
              break
            default:
              if (row.pathOnDisk == '__s3__'){
                cell = 'File uploaded, scanning'
              } else {
                cell = 'Stored'
              }
          }
          return <div className="text-collapse">{cell}</div>
        },
      },
      {
        dataField: 'button',
        text: 'Actions Menu',
        align: 'center',
        formatter: (_, row, rowIndex) => {
          return <FileRestoreActionMenu row={row} itemId={this.props.itemId} />
        },
      },
    ]
    return (
      <RowsContext.Provider value={this.state}>
        <div className="sb-table-listing">
          <BootstrapTable
            responsive
            wrapperClasses="table-responsive"
            keyField="name"
            data={this.state.files}
            columns={columns}
            noDataIndication="This folder has no files yet."
            bordered={false}
            hover
            remote={{
              filter: true,
              pagination: true,
              sort: true,
              cellEdit: false,
            }}
            onTableChange={this.onTableChange}
          />
        </div>
      </RowsContext.Provider>
    )
  }
}

DeletedFileTable.propTypes = {
  itemId: PropTypes.string,
  deletedFiles: PropTypes.array,
  parentId: PropTypes.string,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }),
  history: PropTypes.shape({
    listen: PropTypes.func,
    push: PropTypes.func,
  }),
  match: PropTypes.shape({
    url: PropTypes.string,
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
  canWrite: PropTypes.bool,
}

export default withRouter(DeletedFileTable)

DeletedFileTable.contextType = FolderContext

function FileRestoreActionMenu({ row, itemId }) {
  const [showRestore, setShowRestore] = useState(false)
  const [restoreFailed, setRestoreFailed] = useState(false)
  return (
    <DropdownButton
      style={{ position: 'static' }}
      title=""
      size="sm"
      drop="down"
      alignRight
    >
      <Dropdown.Item
        key={row.id + '_restore'}
        onClick={(e) => {
          e.preventDefault()
          setShowRestore(true)
        }}
      >
        Restore
      </Dropdown.Item>
      <RestoreFileModal
        key={row.id + '_restore_modal'}
        show={showRestore}
        onHide={() => {
          setRestoreFailed(false)
          setShowRestore(false)
        }}
        onRestoreFailed={() => {
          setRestoreFailed(true)
          setShowRestore(true)
        }}
        row={row}
        itemId={itemId}
        restoreFailed={restoreFailed}
      />
    </DropdownButton>
  )
}

FileRestoreActionMenu.propTypes = {
  rowIndex: PropTypes.number,
  client: PropTypes.shape({
    query: PropTypes.func,
  }),
  row: PropTypes.shape({
    cuid: PropTypes.string,
    bucket: PropTypes.string,
    key: PropTypes.string,
    published: PropTypes.bool,
    name: PropTypes.string,
    id: PropTypes.number,
    movedToS3: PropTypes.bool,
    processStatus: PropTypes.string,
    contentType: PropTypes.string,
    location: PropTypes.string,
    scrapeMetadata: PropTypes.any,
    status: PropTypes.shape({
      scanPassed: PropTypes.bool,
    }),
  }),
  itemId: PropTypes.string,
  canWrite: PropTypes.bool,
}
